import React from "react";
import "./ArticleListItem.css";
import {
  makeDateString,
  getDifficultyStr,
} from "../../helpers/helpers";
import { colourSuits } from "../UI/SuitText";

const ArticleListItem = ({
  createdAt,
  body,
  category,
  difficulty,
  id,
  teaser,
  teaser_board,
  title,
  clickHandler,
  router,
  a,
  subscriptionActive,
  hasVideo,
  isFree,
}) => {
  // Article is locked if user is not an admin AND doesn't have an active subscription
  // Admins (a === true) always have access, regardless of subscription status
  const isAdmin = a === true;
  const isLocked = !isAdmin && !subscriptionActive && !isFree;
  
  let articleObj = {
    createdAt,
    category,
    difficulty,
    title,
  };

  const diffString = getDifficultyStr(difficulty);

  const isNewArticle = (createdAt) => {
    if (!createdAt) return false;
    const articleDate = createdAt.toDate ? createdAt.toDate() : new Date(createdAt);
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    return articleDate > thirtyDaysAgo;
  };

  const showNew = isNewArticle(createdAt);

  return (
    <div
      className={`ArticleCard ${isLocked ? 'ArticleCard--locked' : ''} ${isFree ? 'ArticleCard--free' : ''}`}
      onClick={() => clickHandler(articleObj, body)}
    >
      {isLocked && (
        <div className="ArticleCard-lock">
          <svg viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
          </svg>
        </div>
      )}

      {showNew && (
        <div className="ArticleCard-new-badge">NEW</div>
      )}

      {/* Video Badge */}
      {hasVideo && (
        <div className="ArticleCard-video-badge">
          <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '1.6rem', height: '1.6rem' }}>
            <path d="M8 5v14l11-7z"/>
          </svg>
          <span>Article + Video</span>
        </div>
      )}

      <div className="ArticleCard-content">
        <div className="ArticleCard-meta">
          <span className="badge badge-category">{category}</span>
        </div>

        <h3 className="ArticleCard-title">{colourSuits(title)}</h3>

        {teaser && (
          <p className="ArticleCard-teaser">{colourSuits(teaser)}</p>
        )}

        {isLocked && (
          <div className="ArticleCard-locked-overlay">
            <div className="ArticleCard-locked-cta">
              <button className="btn btn-secondary btn-small">
                Start 7-day free trial
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ArticleListItem;
